import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress, Grid } from '@mui/material';
export const PageCircularProgress = () => {
    return (_jsx(Grid, { container: true, spacing: 0, direction: "column", alignItems: "center", justifyContent: "center", style: { minHeight: '100vh' }, children: _jsx(Grid, { item: true, xs: 3, children: _jsx(CircularProgress, { size: 50 }) }) }));
};
